import script from "./postcode-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./postcode-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./postcode-lookup.vue?vue&type=style&index=0&id=0f606b16&lang=scss"

const __exports__ = script;

export default __exports__